import React, { useState } from 'react';
import { Star } from 'lucide-react';

export default function StarRating({ value = 0, onChange, size = 5 }) {
  const [hover, setHover] = useState(0);
  const interactive = !!onChange;
  const sizeClass = size === 4 ? 'h-4 w-4' : size === 6 ? 'h-6 w-6' : 'h-5 w-5';

  return (
    <div className="flex items-center space-x-1" data-testid="star-rating">
      {[1, 2, 3, 4, 5].map((star) => (
        <Star
          key={star}
          data-testid={`star-${star}`}
          className={`${sizeClass} ${interactive ? 'cursor-pointer' : ''} ${
            star <= (hover || value) ? 'fill-yellow-400 text-yellow-400' : 'text-gray-300'
          }`}
          onClick={interactive ? () => onChange(star) : undefined}
          onMouseEnter={interactive ? () => setHover(star) : undefined}
          onMouseLeave={interactive ? () => setHover(0) : undefined}
        />
      ))}
    </div>
  );
}
